import axiosInstance from "../../apiAxios/axiosInstance";

export const PurchaseList = async (payload) => {
  const response = await axiosInstance.post("/vendor/purchase-list", payload);
  return response.data;
};
export const ActivePurchaseList = async(payload) => {
   const resposne=await axiosInstance.post("/vendor/active-purchase-list",payload);
   return resposne.data
};
export const BrandBasePurchaseList = async(payload) => {
   const resposne=await axiosInstance.post("/vendor/brand-base-product-list",payload);
   return resposne.data
};
export const AddPurchase = async (payload) => {
  const response = await axiosInstance.post("/vendor/purchase-store", payload);
  return response.data;
};

export const ViewPurchaseProducts = async (payload) => {
  const response = await axiosInstance.post("/vendor/purchase-show", payload);
  return response.data;
};

export const UpdatePurchase = async (payload) => {
  const response = await axiosInstance.post("/vendor/purchase-update", payload);
  return response.data;
};

export const DeletePurchase = async (payload) => {
  const response = await axiosInstance.post("/vendor/purchase-delete", payload);
  return response.data;
};

export const PurchaseChangeStatus = async (payload) => {
  const response = await axiosInstance.post(
    "/vendor/purchase-status-update",
    payload
  );
  return response.data;
};